import { createSelector } from 'reselect';
import { getSupportContacts } from '../rootSelectors';

const getContactsSupport = createSelector([getSupportContacts], contact => contact.data);

export { getContactsSupport };
